const STORAGE_KEY = "mx_inspiration_gallery_pending_uploads";
const BULK_SNAPSHOT_KEY = "mx_inspiration_gallery_bulk_snapshot";

export function getPendingInspirationUploadIds() {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? [...new Set(parsed.filter(Boolean))] : [];
    } catch {
        return [];
    }
}

export function addPendingInspirationUploadId(id) {
    if (!id) return;
    try {
        const cur = new Set(getPendingInspirationUploadIds());
        cur.add(id);
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify([...cur]));
    } catch {
        /* quota / private mode */
    }
}

export function removePendingInspirationUploadId(id) {
    if (!id) return;
    try {
        const next = getPendingInspirationUploadIds().filter((x) => x !== id);
        if (next.length === 0) sessionStorage.removeItem(STORAGE_KEY);
        else sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
        /* ignore */
    }
}

/** Persist bulk job summary so refresh can restore the combined progress bar + SSE mode. */
export function persistInspirationBulkGalleryStart({ total }) {
    if (!total || total < 1) return;
    try {
        sessionStorage.setItem(
            BULK_SNAPSHOT_KEY,
            JSON.stringify({
                total,
                completed: 0,
                currentIndex: 0,
                currentTitle: "",
                currentFile: "",
                currentPercent: 0,
            })
        );
    } catch {
        /* ignore */
    }
}

export function persistInspirationBulkGalleryCurrentItem({ index, title }) {
    try {
        const raw = sessionStorage.getItem(BULK_SNAPSHOT_KEY);
        const base = raw ? JSON.parse(raw) : {};
        if (!base || typeof base.total !== "number") return;
        const next = {
            ...base,
            currentIndex: index ?? base.currentIndex ?? 0,
            currentTitle: title ?? base.currentTitle ?? "",
        };
        sessionStorage.setItem(BULK_SNAPSHOT_KEY, JSON.stringify(next));
    } catch {
        /* ignore */
    }
}

export function incrementInspirationBulkSnapshotCompleted() {
    try {
        const raw = sessionStorage.getItem(BULK_SNAPSHOT_KEY);
        if (!raw) return;
        const s = JSON.parse(raw);
        if (!s || typeof s.total !== "number") return;
        s.completed = Math.min(s.total, (s.completed || 0) + 1);
        sessionStorage.setItem(BULK_SNAPSHOT_KEY, JSON.stringify(s));
    } catch {
        /* ignore */
    }
}

export function readInspirationBulkSnapshot() {
    try {
        const raw = sessionStorage.getItem(BULK_SNAPSHOT_KEY);
        if (!raw) return null;
        const s = JSON.parse(raw);
        if (!s || typeof s.total !== "number" || s.total < 1) return null;
        return s;
    } catch {
        return null;
    }
}

export function clearInspirationBulkSnapshot() {
    try {
        sessionStorage.removeItem(BULK_SNAPSHOT_KEY);
    } catch {
        /* ignore */
    }
}
